import React from "react";
import { Box, Container } from "@mui/material";
import { ItemIssueReturnList } from "../../components/ItemIssueReturn/ItemIssueReturnList";

export const InvItemIssueReturnsPage = () => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 4 }}>
        <ItemIssueReturnList />
      </Box>
    </Container>
  );
};
